export default __webpack_public_path__ + "static/media/maestro.8fb0e2fb.svg";